var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-input"},[_c('i',{staticClass:"leading-icon icon-search"}),_c('input',{staticClass:"searchInput",attrs:{"tabindex":"0","type":"text","placeholder":_vm.placeholder},on:{"input":function($event){return _vm.inputOnchange($event)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }